//import { register } from "@parcel/service-worker"; // doesn't exist
//import { Dictionaries } from "./managers/Dictionaries.ts";
//import Bowser from "bowser";
import "@ungap/custom-elements"; // needed for safari "is" attribute
import { HeartBank } from "./managers/HeartBank.ts";
import { LANGUAGE, isProduction } from "./components/global.ts";
import Strings from "./models/Strings.json";

import { analytics, performance } from "./firebase.ts";
import { trace } from "firebase/performance";
import { logEvent, setUserProperties } from "firebase/analytics";

import { SwFooter } from "./components/sw-footer/sw-footer.ts";
import { SwAlert } from "./components/sw-footer/sw-alert/sw-alert.ts";
import { SwDonate } from "./components/sw-footer/sw-donate/sw-donate.ts";
import { SwFeedback } from "./components/sw-footer/sw-feedback/sw-feedback.ts";
import { SwMovie } from "./components/sw-footer/sw-movie/sw-movie.ts";
import { SwPopup } from "./components/sw-footer/sw-popup/sw-popup.ts";

import { SwHeader } from "./components/sw-header/sw-header.ts";
import { SwBanner } from "./components/sw-header/sw-banner/sw-banner.ts";
import { SwEditor } from "./components/sw-header/sw-editor/sw-editor.ts";
import { SwMenu } from "./components/sw-header/sw-menu/sw-menu.ts";
import { SwToc } from "./components/sw-header/sw-toc/sw-toc.ts";

import { SwMap } from "./components/sw-main/sw-map/sw-map.ts";
import { SwHome } from "./components/sw-main/sw-home/sw-home.ts";
import { SwPage } from "./components/sw-main/sw-page/sw-page.ts";
import { SwReader } from "./components/sw-main/sw-reader/sw-reader.ts";
import { SwDictionary } from "./components/sw-main/sw-dictionary/sw-dictionary.ts";
import { SwMain } from "./components/sw-main/sw-main.ts";

import { SwBedok } from "./components/sw-bedok.ts";
import { SwCode } from "./components/sw-header/sw-code/sw-code.ts";
import { SwShare } from "./components/sw-main/sw-share/sw-share.ts";
//import "flowbite"; //TODO: refactor out to import components individually

customElements.define("sw-map", SwMap);
customElements.define("sw-home", SwHome);
customElements.define("sw-reader", SwReader);
customElements.define("sw-dictionary", SwDictionary);
customElements.define("sw-main", SwMain);

customElements.define("sw-popup", SwPopup);
customElements.define("sw-alert", SwAlert);
customElements.define("sw-donate", SwDonate);
customElements.define("sw-feedback", SwFeedback);
customElements.define("sw-movie", SwMovie);
customElements.define("sw-footer", SwFooter);

customElements.define("sw-share", SwShare);
customElements.define("sw-code", SwCode);
customElements.define("sw-banner", SwBanner);
customElements.define("sw-menu", SwMenu);
customElements.define("sw-toc", SwToc);
customElements.define("sw-editor", SwEditor);

//order is important!!! TODO: refactor move to class like hb apps
customElements.define("sw-header", SwHeader);
customElements.define("sw-page", SwPage);

customElements.define("sw-bedok", SwBedok, { extends: "body" });

setUserProperties(analytics, { membership_tier: "basic" });
const pageLoadTrace = trace(performance, "sw-bedok");
//pageLoadTrace.putAttribute("view", "sw-bedok");
pageLoadTrace.start();

declare global {
    interface Window {
        heartbank: HeartBank;
        vault: (page: "login" | "logout" | "humanity" | "passkeys") => void;

        removeReader: (id: string) => void;

        editTempleLink: (id: string, link: string) => void;
        editTempleName: (id: string, name: string) => void;
        editTempleAddress: (id: string, address: string) => void;
        editTemplePhoto: (id: string, photo: string) => void;
        publishTemple: (id: string, name: string) => void;
        unpublishTemple: (id: string, name: string) => void;
        addTemple: (
            latitude: number,
            longitude: number,
            address: string
        ) => void;
        removeTemple: (id: string, pid: string) => void;
    }
}

const strings: any = Strings;
window.heartbank = new HeartBank();

window.vault = (page: "login" | "logout" | "humanity" | "passkeys") => {
    //const thank = document.querySelector("sw-feedback") as SwFeedback;
    const popup = document.querySelector("sw-popup") as SwPopup;
    switch (page) {
        case "login":
            //thank.show();
            if (!window.heartbank.user) popup.openVault("login");
            break;
        case "logout":
            if (confirm(strings.map19[LANGUAGE]) && window.heartbank.user)
                popup.openVault("logout");
            break;
        case "humanity":
            if (window.heartbank.user) popup.openVault("humanity"); // humanity/silver
            break;
        case "passkeys":
            if (window.heartbank.user) popup.openVault("lockbox");
            break;
    }
    window.heartbank.alertAdmin("map/profile/click/", page);
};

window.addEventListener("load", () => {
    logEvent(analytics, "app_open");
    if (isProduction) registerServiceWorker();
    //registerServiceWorker(); // for testin
});

document.addEventListener("DOMContentLoaded", () => {
    if (
        location.hostname !== "localhost" &&
        location.hostname !== "127.0.0.1"
    ) {
        const script = document.createElement("script");
        script.defer = true;
        script.src = "https://static.cloudflareinsights.com/beacon.min.js";
        script.setAttribute(
            "data-cf-beacon",
            '{"token": "67c4db43f5f04360be914f2ee3f0137a"}'
        );
        document.head.appendChild(script);
    }

    // const browser = Bowser.getParser(window.navigator.userAgent);
    // const browserName = browser.getBrowserName();
    // const browserVersion = parseFloat(browser.getBrowserVersion() || "0");

    // if (browserName === "Chrome") {
    //     if (browserVersion < 54)
    //         alert(
    //             "Chrome version 54 or above is required. Please upgrade and try again."
    //         );
    // }

    // if (browserName === "Safari") {
    //     if (browserVersion < 10.1)
    //         alert(
    //             "Safari version 10.1 or above is required. Please upgrade and try again."
    //         );
    // }

    // const dictionaries = new Dictionaries();
    // await dictionaries.loadDictionary();
    document.body.style.visibility = "visible";
    pageLoadTrace.incrementMetric("count", 1);
    pageLoadTrace.stop();
});

function registerServiceWorker() {
    if ("serviceWorker" in navigator) {
        navigator.serviceWorker
            .register(new URL("./sw.ts", import.meta.url), {
                scope: "/",
                type: "module"
            })
            .then((registration: ServiceWorkerRegistration) => {
                registration.onupdatefound = () => {
                    const installingWorker = registration.installing;
                    if (installingWorker) {
                        installingWorker.onstatechange = () => {
                            if (installingWorker.state === "installed") {
                                if (navigator.serviceWorker.controller) {
                                    //localStorage.setItem("updateAvailable", "true"); // redundant bc skiipwaiting
                                }
                            }
                        };
                    }
                };
                registration.update(); //force update when new version is available bc pwa home app
                console.log(
                    "Service Worker registered with scope: ",
                    registration.scope
                );
            })
            .catch((error: any) => {
                console.error("Service Worker registration failed: ", error);
            });

        // navigator.serviceWorker.getRegistrations().then((registrations) => {
        //     console.log(registrations);
        //     if (registrations.length === 0) {
        //         console.warn("No Service Workers are registered.");
        //     } else {
        //         console.log("Service Worker registered: ", registrations);
        //     }
        // });
    }
}
